import { Group, Header, Button, SimpleCell } from '@vkontakte/vkui';
import React from 'react';
import { useAppContext } from '../../AppContext';
import { APP_PLATFORM_TYPE_VK } from '../../App';
import { Modals } from '../../Consts';
import { useAppStore } from '../../AppStore';

const CURRENT_COMPONENT = 'VkScanReceipt';
export const VkLimits = ({}) => {
  const context = useAppContext();
  const appStore = useAppStore();

  if (context.platform !== APP_PLATFORM_TYPE_VK) {
    return (<></>);
  }

  if (!context.getBridge().bridge.supports('VKWebAppShowOrderBox')) {
    return (<></>);
  }

  if (context.appOpenParams?.vk_platform === 'desktop_web_messenger') {
    return (<></>);
  }

  const receiptScansTextVotes = context.lang().declOfNum(CURRENT_COMPONENT, 'remaining_receipt_scans_count', appStore.remainingReceiptScansCount);
  const eventsTextVotes = context.lang().declOfNum(CURRENT_COMPONENT, 'remaining_events_count', appStore.remainingEventsCount);

  return (<Group
    header={<Header mode="secondary">
      {context.lang().getKey(CURRENT_COMPONENT, 'header')}
    </Header>}
  >
    <SimpleCell
      after={
        <Button
          label={context.lang().getKey(CURRENT_COMPONENT, 'receipt_scans_button_label')}
          onClick={() => context.router.showModal(Modals.BUY_RECEIPT_SCANS_MODAL)}
        >
          {context.lang().getKey(CURRENT_COMPONENT, 'receipt_scans_button_label')}
        </Button>
      }
      subtitle={receiptScansTextVotes}
    >
      {context.lang().getKey(CURRENT_COMPONENT, 'receipt_scans_header')}
    </SimpleCell>
    <SimpleCell
      after={
        <Button
          label={context.lang().getKey(CURRENT_COMPONENT, 'events_button_label')}
          onClick={() => context.router.showModal(Modals.BUY_EVENTS_MODAL)}
        >
          {context.lang().getKey(CURRENT_COMPONENT, 'events_button_label')}
        </Button>
      }
      subtitle={eventsTextVotes}
    >
      {context.lang().getKey(CURRENT_COMPONENT, 'events_header')}
    </SimpleCell>
  </Group>);
}